import { useEffect, useState } from 'react';

/**
 * Hook que devuelve `Date` actualizado periódicamente. Usado en InicioPage
 * para el reloj en el header (HH:MM). Default 30 segundos — suficiente
 * para minutos en pantalla sin tirar de batería en móvil.
 *
 * Pausa el timer cuando el documento está oculto (otra tab/app), se
 * reanuda al volver. Sirve además un único `Date` inicial estable durante
 * el primer render para evitar flash de SSR vs CSR.
 */
export function useNow(intervalMs = 30_000): Date {
  const [now, setNow] = useState<Date>(() => new Date());

  useEffect(() => {
    let timer: number | undefined;
    const tick = (): void => { setNow(new Date()); };

    const start = (): void => {
      tick();
      timer = window.setInterval(tick, intervalMs);
    };
    const stop = (): void => {
      if (timer !== undefined) {
        window.clearInterval(timer);
        timer = undefined;
      }
    };
    const onVisibility = (): void => {
      if (document.hidden) stop();
      else start();
    };

    start();
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [intervalMs]);

  return now;
}
